import { Suspense, Fragment } from 'react';
import { t } from 'ttag';
import { Helmet } from 'react-helmet';
import { useMatches, Outlet } from 'react-router-dom';
import { APP } from 'constants.js';
import useShallowEqualSelector from 'hooks/useShallowEqualSelector.js';
import TopNotification from 'components/layouts/TopNotification/index.js';
import OperatorNavigator from 'components/layouts/OperatorNavigator/index.js';
import PersonNavigator from 'components/layouts/PersonNavigator/index.js';
import RouteLoading from 'components/layouts/LoadingViews/RouteLoading.js';
import CookieBanner from 'components/layouts/CookieBanner/index.js';
import LanguageSwitcher from 'components/LanguageSwitcher/index.js';
import './index.scss';

// Renders an <Outlet /> component from the react-router-dom library, so basically the view element of the current route
// Also wraps it in <React.Suspense fallback={...} />, which is displayed while the view is loading
const CoreLayout = ({ app }) => {
    const matches = useMatches();
    const { getTitle } = matches.find(match => match.handle?.getTitle)?.handle || {};

    const lang = useShallowEqualSelector(state => state.layout.lang);

    const isOperatorApp = app === APP.OPERATOR;
    const isPersonApp = app === APP.PERSON;

    return (
        <Fragment key={lang}>
            <Helmet htmlAttributes={{ lang }}>
                <title>{getTitle?.() || ''}{t`TAB_TITLE_SUFFIX`}</title>
                <meta name='description' content={t`WEBSITE_META_DESCRIPTION`} />
            </Helmet>
            <CookieBanner />
            <div className={`core-wrapper ${isOperatorApp ? 'is-operator' : ''} ${isPersonApp ? 'is-person' : ''}`}>
                <TopNotification />
                {isOperatorApp && <OperatorNavigator />}
                {isPersonApp && <PersonNavigator />}
                <div className='core-content'>
                    <LanguageSwitcher />
                    <Suspense fallback={<RouteLoading />}>
                        <Outlet />
                    </Suspense>
                </div>
            </div>
        </Fragment>
    );
};

export default CoreLayout;
